import { makeStyles } from '@material-ui/core/styles';
import { calculateHeight, calculateWidth, rem, vw } from '../../../common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  item: {
    width: '55.93vw',
    fontSize: rem(1.125),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: calculateHeight(20).stringValue,
    letterSpacing: '1.25px',
    color: themeColor.modalTitle,
  },
  itemDetails: {
    paddingTop: calculateHeight(42.5).stringValue,
  },
  itemDetailsContainer: {
    maxHeight: calculateHeight(20).stringValue,
    paddingLeft: '2vw',
    paddingRight: '2vw',
    '@media (max-width: 1024px) and (max-height: 576px)': {
      maxHeight: calculateHeight(50).stringValue,
    },
  },
  itemOverflow: {
    height: '9.16vh',
    width: '55.93vw',
    fontSize: vw(1.77),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: '1.25px',
    color: themeColor.modalTitle,
    marginLeft: '1.53vw',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  itemPrice: {
    height: '2.6vh',
    fontSize: rem(1.25),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.11',
    letterSpacing: '0.17px',
    color: themeColor.defaultTextColor,
    alignSelf: 'flex-end',
    textAlign: 'center',
    display: 'inline-block',
    whiteSpace: 'pre',
  },
  itemCode: {
    height: '3.12vh',
    width: '20.93vw',
    fontSize: rem(1),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.25',
    letterSpacing: '0.44px',
    color: `${theme.palette.info.main}`,
    alignSelf: 'flex-start',
  },
  priceUnit: {
    display: 'inline-block',
    fontSize: rem(0.875),
    color: `${theme.palette.info.main}`,
  },
  originalPrice: {
    display: 'inline-block',
    fontSize: rem(1.125),
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: calculateHeight(20).stringValue,
    letterSpacing: '1.25px',
    color: themeColor.modalTitle,
  },
  subHeading: {
    fontSize: rem(1.125),
    display: 'inline-block',
    top: '30%',
    position: 'relative',
  },
  selectedSubHeading: {
    color: themeColor.bigstones,
  },
  uncheckedSubHeading: {
    color: theme.palette.info.dark,
  },
  outerMostContainer: {
    width: '0',
    marginLeft: '1vh',
  },
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  priceOverrideContainer: {
    padding: 10,
  },
  outerFlexDesign: {
    flex: '1 1 0',
  },
  priceOverrideTitleContainer: {
    height: calculateHeight(67.64).stringValue,
  },
  priceOverrideTitleBar: {
    color: themeColor.infoMain,
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
    height: calculateHeight(4.9).stringValue,
    width: calculateWidth(50).stringValue,
  },
  priceOverrideTitleHeader: {
    color: themeColor.modalTitle,
  },
  fitHeight: {
    height: 'fit-content',
  },
  flexDesign: {
    flex: 1,
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  buttonStyles: {
    fontSize: rem(1),
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  priceInput: {
    justifyContent: 'flex-end',
  },
  switchContainer: { position: 'relative', top: 50 },
}));
